<template>
  <Dialog v-model:visible="videoPlayerDialog" @hide="onClose">
    <video ref="alarmTableItemModalPlayer"
           autoplay
           class="video-js"
           controls
           cors="anonymous"
           crossorigin="anonymous"
           data-setup='{}'
           preload="false"
           style="width: 800px; height: 600px;"
    >
      <p class="vjs-no-js">To view this video please enable JavaScript</p>
    </video>
  </Dialog>
  <Dialog v-model:visible="pdfDisplayDialog" @hide="onClose">
    <iframe
        loading="lazy"
        ref="alarmTableItemPDFViewer"
        style="width: 800px; height: 600px;"
    />
  </Dialog>
  <Dialog v-model:visible="imageDisplayDialog" @hide="onClose">
    <img
        loading="lazy"
        ref="alarmTableItemImageViewer"
        style="width: 800px; height: 600px;"
        alt="image"
    />
  </Dialog>
</template>

<script>
import request from "@/api/request";
import { downloadInstruction } from "@/api/instruction";
import { logError } from "@/utils/appLogger";
import 'video.js/dist/video';
import 'video.js/dist/video-js.css';

export default {
  name: "FileViewer",
  props: {
    file: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      videoPlayerDialog: false,
      pdfDisplayDialog: false,
      imageDisplayDialog: false,
    };
  },
  mounted() {
    if (this.file) {
      this.openFile(this.file);
    }
  },
  methods: {
    openFile(file) {
      const extension = file.split('.').pop().toLowerCase();
      let src = '';
      let type;

      if (extension === 'mp4') {
        this.videoPlayerDialog = true;
      } else if (extension === 'pdf') {
        this.pdfDisplayDialog = true;
        type = 'application/pdf';
      } else if (['png', 'jpg', 'jpeg', 'gif'].includes(extension)) {
        this.imageDisplayDialog = true;
        type = 'image/' + extension;
      }

      request({
        url: `/list/instruction-files-content`,
        method: 'get',
        responseType: 'arraybuffer',
        params: { filename: file }
      }).then((response) => {
        if (extension === 'mp4') {
          type = response.headers['content-type'];
        }

        src = window.URL.createObjectURL(new Blob([response.data], {
          type,
          encoding: 'ISO-8859-1'
        }));

        if (extension === 'mp4') {
          this.$refs.alarmTableItemModalPlayer.src = src;
        } else if (extension === 'pdf') {
          this.$refs.alarmTableItemPDFViewer.src = src;
        } else if (['png', 'jpg', 'jpeg', 'gif'].includes(extension)) {
          this.$refs.alarmTableItemImageViewer.src = src;
        } else {
          downloadInstruction(file);
        }
      }).catch((error) => {
        logError('open instruction file failed', error);
      });
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>
